import React, { useState } from "react";
import { Stars, CatTag } from "./helpers";

export default function ProveedorCard({ p, onEditar, onEliminar, onVer360 }) {
  const [confirmDel, setConfirmDel] = useState(false);

  const contactos = p.contactos?.length > 0
    ? p.contactos
    : (p.contacto ? [{ nombre: p.contacto, zona: "", telefono: p.telefono || "" }] : []);

  const categorias = p.categorias?.length > 0
    ? p.categorias
    : (p.materiales ? p.materiales.split(",").map(m => m.trim()).filter(Boolean) : []);

  const principales = contactos.slice(0, 2);
  const extras      = contactos.length - 2;

  return (
    <div className="card-lift" style={{ background: "#fff", border: "0.5px solid #e2e8f0", borderRadius: 12, padding: "14px 16px", display: "flex", flexDirection: "column", gap: 10 }}>

      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#1e293b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {p.nombreComercial || p.nombre}
          </div>
          {p.nombreComercial && p.nombre && (
            <div style={{ fontSize: 10, color: "#64748b", marginTop: 1, fontStyle: "italic", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {p.nombre}
            </div>
          )}
          <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2 }}>
            {[p.ruc && `RUC ${p.ruc}`, p.ciudad].filter(Boolean).join(" · ")}
          </div>
        </div>
        <Stars n={p.calificacion} />
      </div>

      {categorias.length > 0 ? (
        <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
          {categorias.slice(0, 5).map(c => <CatTag key={c} label={c} />)}
          {categorias.length > 5 && (
            <span style={{ fontSize: 10, color: "#94a3b8", padding: "2px 5px" }}>+{categorias.length - 5}</span>
          )}
        </div>
      ) : (
        <div style={{ fontSize: 11, color: "#94a3b8", fontStyle: "italic" }}>Sin categorías</div>
      )}

      {contactos.length > 0 ? (
        <div style={{ borderTop: "0.5px solid #f1f5f9", paddingTop: 8, display: "flex", flexDirection: "column", gap: 5 }}>
          {principales.map((c, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 6 }}>
              <div style={{ fontSize: 12, color: "#1e293b", flex: 1, minWidth: 0 }}>
                <span style={{ fontWeight: 600 }}>👤 {c.nombre}</span>
                {c.zona && <span style={{ fontSize: 10, color: "#854F0B", fontWeight: 600 }}> · 📍{c.zona}</span>}
              </div>
              {c.telefono && (
                <button onClick={() => window.open(`https://wa.me/51${c.telefono.replace(/\D/g,"")}`, "_blank")}
                  style={{ fontSize: 10, padding: "2px 7px", borderRadius: 5, background: "#dcf8c6", color: "#128c7e", border: "none", cursor: "pointer", fontWeight: 600, whiteSpace: "nowrap" }}>
                  📱 WA
                </button>
              )}
            </div>
          ))}
          {extras > 0 && (
            <button onClick={() => onVer360(p)} style={{ fontSize: 10, color: "#3A3C7A", background: "none", border: "none", cursor: "pointer", textAlign: "left", padding: 0, fontWeight: 600 }}>
              +{extras} contacto{extras > 1 ? "s" : ""} más →
            </button>
          )}
        </div>
      ) : (
        <div style={{ fontSize: 11, color: "#94a3b8", fontStyle: "italic", borderTop: "0.5px solid #f1f5f9", paddingTop: 8 }}>
          Sin contactos registrados
        </div>
      )}

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 6, borderTop: "0.5px solid #f1f5f9", paddingTop: 8 }}>
        <div style={{ display: "flex", gap: 5 }}>
          {p.plazoDias   && <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 7px", borderRadius: 5, background: "#EEF2FF", color: "#3A3C7A" }}>📦 {p.plazoDias}d</span>}
          {p.creditoDias && <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 7px", borderRadius: 5, background: "#E1F5EE", color: "#0F6E56" }}>💳 {p.creditoDias}d</span>}
        </div>
        <div style={{ display: "flex", gap: 5 }}>
          <button onClick={() => onVer360(p)} style={{ fontSize: 10, padding: "4px 9px", borderRadius: 6, background: "#EEF2FF", color: "#3A3C7A", border: "none", cursor: "pointer", fontWeight: 700 }}>
            360°
          </button>
          <button onClick={() => onEditar(p)} style={{ fontSize: 10, padding: "4px 8px", borderRadius: 6, background: "#dbeafe", color: "#1d4ed8", border: "none", cursor: "pointer", fontWeight: 600 }}>
            Editar
          </button>
          {confirmDel ? (
            <>
              <button onClick={() => { onEliminar(p.id); setConfirmDel(false); }} style={{ fontSize: 10, padding: "4px 8px", borderRadius: 6, background: "#DC2626", color: "#fff", border: "none", cursor: "pointer", fontWeight: 600 }}>Sí</button>
              <button onClick={() => setConfirmDel(false)} style={{ fontSize: 10, padding: "4px 7px", borderRadius: 6, background: "#f1f5f9", color: "#475569", border: "none", cursor: "pointer" }}>No</button>
            </>
          ) : (
            <button onClick={() => setConfirmDel(true)} style={{ fontSize: 10, padding: "4px 8px", borderRadius: 6, background: "#fee2e2", color: "#991b1b", border: "none", cursor: "pointer", fontWeight: 600 }}>
              Del
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
